module.exports = __webpack_public_path__ + "static/media/Barmag FK6 700 Drive.04e446e3.jpg";